import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[escapeAwareMaxLength]',
  standalone: true
})
export class EscapeAwareMaxLengthDirective {

  @Input() escapeAwareMaxLength!: number;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const value = event.target.value;
    const escapedLength = this.calculateEscapedLength(value);

    if (escapedLength > this.escapeAwareMaxLength) {
      // Megakadályozza a további karakterek bevitelét
      event.preventDefault();
      event.target.value = this.truncateToMaxLength(value);
      // Trigger input event to update ngModel
      this.triggerInputEvent(event.target);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') || '';
    const currentValue = (event.target as HTMLInputElement).value;
    const truncatedText = this.truncateToMaxLength(currentValue + pastedText);
    (event.target as HTMLInputElement).value = truncatedText;
    // Trigger input event to update ngModel
    this.triggerInputEvent(event.target as HTMLInputElement);
  }

  private triggerInputEvent(element: HTMLInputElement) {
    // Create and dispatch input event to notify Angular of the change
    const inputEvent = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    element.dispatchEvent(inputEvent);
  }

  private calculateEscapedLength(value: string): number {
    if (!value) return 0;

    let escapedLength = 0;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char === '\\' || char === '\n' || char === '\r' || char === '\t' || char === '"') {
        escapedLength += 2;
      } else {
        escapedLength += 1;
      }
    }
    return escapedLength;
  }

  private truncateToMaxLength(value: string): string {
    let result = '';
    let escapedLength = 0;

    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      const charLength = (char === '\\' || char === '\n' || char === '\r' || char === '\t' || char === '"') ? 2 : 1;

      if (escapedLength + charLength <= this.escapeAwareMaxLength) {
        result += char;
        escapedLength += charLength;
      } else {
        break;
      }
    }

    return result;
  }

}
